//
//
//
//

import faqSeoMixin from '@/mixins/faqSeoMixin'

const defaultComponents = {
  desktop: () =>
    import(/* webpackChunkName:'views/faq/index' */ '@/views/faq/index.vue'),
  mobile: () =>
    import(/* webpackChunkName:'views/faq/m_index' */ '@/views/faq/m_index.vue')
}

export default {
  name: 'FaqPage',
  components: {
    ...defaultComponents
  },
  mixins: [faqSeoMixin],
  layout: ({ isMobile }) => (isMobile ? 'mobile' : 'desktop'),
  scrollToTop: true,
  // The category landing (/help/<type>) gets its head here, not in its own
  // page at _type/index.vue: the mobile view renders the landing's section
  // list itself and only places <nuxt-child> for sections and cases, so that
  // child page is never mounted on mobile and a head declared there reached
  // desktop visitors only. This page is mounted for every /help/<type> route
  // on both renderers. Sections and cases do mount their own page on both and
  // own their head, so they get the generic one from here.
  head() {
    const generic = this.$seoTagBuilder({
      ...this.$i18nSeo({
        meta: [
          ...this.getDefaultMeta().meta,
          {
            hid: 'og:title',
            property: 'og:title',
            content: `${this.$t('global.faq')}`
          }
        ],
        title: `${this.$t('global.faq')}`
      })
    })

    return this.$route.params.section ? generic : this.faqSeoHead(generic)
  },
  computed: {
    renderViewType() {
      return this.$store.state.app.browserType
    }
  }
}
